import { AppraisalUtmStorage } from 'site-modules/shared/components/appraisal/appraisal-utm-storage/appraisal-utm-storage';

export const getIsOptimizedTraffic = ({ isAppExtensionPage, location }) => {
  const isUtmAccountAppraisal =
    AppraisalUtmStorage.isUtmAccountQueryParamAppraisals(location) || AppraisalUtmStorage.isSemCampaignAppraisals;
  const isUtmSourceFacebook =
    AppraisalUtmStorage.isUtmSourceQueryParamFacebook(location) || AppraisalUtmStorage.isSemCampaignFacebook;
  return [isUtmAccountAppraisal, isUtmSourceFacebook, isAppExtensionPage].some(e => !!e);
};
